import van from "vanjs-core";
import {pageState, PageStateObj, type StateEventDetail} from "@commons/layout/pageState";
import {Net} from "@utils/net";
const {div} = van.tags;
import {HtmlTitle} from "@commons/site/htmlTitle";
import {UserLogin} from "@commons/site/userLogin";
import {StringUtil} from "@utils/stringUtil";
import {HqLoginPanel} from "@hq/login/hqLoginPanel";
import {Alert} from "@commons/components/bootstrap/alert";
import {HqLoginUtil} from "@hq/login/hqLoginUtil";
import {Busy} from "@commons/layout/busy";
import type {HqLoginPageResponse} from "hq-dto";
import '@utils/importCss';
import type {HqLoginResponse} from "hq-dto";

export class HqLoginPage
{
    #alert: Alert;
    #loginPanel: HqLoginPanel;
    
    constructor() 
    {
        this.#alert = new Alert();
        this.#loginPanel = new HqLoginPanel(this, this.#alert);
        
        this.#alert.init({ style: 'max-width: 500px'});
    }
    
    toDom(): HTMLElement
    {
        let center = div({"class": "d-flex" },
            div({ class: "flex-grow-1"}),
            this.#loginPanel.toDom(),
            div({ class: "flex-grow-1"})
        );

        let alertRow = div({"class": "d-flex", "style": "min-height: 75px" },
            div({ class: "flex-grow-1"}),
            this.#alert.toDom(),
            div({ class: "flex-grow-1"})
        );

        return div({'data-van-component':  StringUtil.camelToKebab(this.constructor.name)},
            div({ style: "padding: 20px 0"}),
            alertRow,
            center
        );
    }

    onLogin(loginResponse: HqLoginResponse): void
    {
        if (loginResponse.applicationName)
            HtmlTitle.applicationName = loginResponse.applicationName;
        
        if (loginResponse.hasError)
        {
            this.#alert.show(loginResponse.errorMessage);
            return;
        }

        HqLoginUtil.resetLocalStorage(loginResponse);
        window.location.href = loginResponse.url!;
    }
    
    setState(state: PageStateObj): Promise<void>
    {
        let busyCancel = Busy.instance.setBusy();
        return Net
            .get<HqLoginPageResponse>({ 
                url: '/login/getLoginPage/', 
                queryParams: { returnUrl: state.returnUrl } 
            })
            .then((loginPageResponse: HqLoginPageResponse) =>
            {
                this.#loginPanel.model = loginPageResponse;
                HtmlTitle.applicationName = loginPageResponse.applicationName;
                HtmlTitle.pageTitle = 'Login';
            })
            .finally(busyCancel);
    }
    
    onUnhandledRejection(event: PromiseRejectionEvent): void
    {
        event.preventDefault();
        this.#alert.show(event.reason ?? 'Unhandled Rejection');
    }
}

// Clears browser persisted log-in info
UserLogin.instance = new UserLogin();

let page = new HqLoginPage();
window.addEventListener("unhandledrejection", evt => page.onUnhandledRejection(evt));
pageState.registerPage((detail: StateEventDetail) => page.setState(detail.state));
van.add(document.body, page.toDom());